// source: authz/annotations.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
var authz_permissions_pb = require('../authz/permissions_pb.js');
goog.object.extend(proto, authz_permissions_pb);
goog.exportSymbol('proto.authz.AUTHZ_MODE', null, global);
goog.exportSymbol('proto.authz.anyOfCapabilitiesList', null, global);
goog.exportSymbol('proto.authz.authzMode', null, global);
goog.exportSymbol('proto.authz.requiredCapabilitiesList', null, global);
/**
 * @enum {number}
 */
proto.authz.AUTHZ_MODE = {
  UNSPECIFIED: 0,
  PUBLIC: 1,
  PROTECTED: 2,
  INTERNAL: 3
};


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `authzMode`.
 * @type {!jspb.ExtensionFieldInfo<!proto.authz.AUTHZ_MODE>}
 */
proto.authz.authzMode = new jspb.ExtensionFieldInfo(
    50001,
    {authzMode: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    0);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[50001] = new jspb.ExtensionFieldBinaryInfo(
    proto.authz.authzMode,
    jspb.BinaryReader.prototype.readEnum,
    jspb.BinaryWriter.prototype.writeEnum,
    undefined,
    undefined,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[50001] = proto.authz.authzMode;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `requiredCapabilitiesList`.
 * @type {!jspb.ExtensionFieldInfo<!Array<!proto.authz.CAPABILITY>>}
 */
proto.authz.requiredCapabilitiesList = new jspb.ExtensionFieldInfo(
    50002,
    {requiredCapabilitiesList: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    1);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[50002] = new jspb.ExtensionFieldBinaryInfo(
    proto.authz.requiredCapabilitiesList,
    jspb.BinaryReader.prototype.readPackedEnum,
    jspb.BinaryWriter.prototype.writePackedEnum,
    undefined,
    undefined,
    true);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[50002] = proto.authz.requiredCapabilitiesList;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `anyOfCapabilitiesList`.
 * @type {!jspb.ExtensionFieldInfo<!Array<!proto.authz.CAPABILITY>>}
 */
proto.authz.anyOfCapabilitiesList = new jspb.ExtensionFieldInfo(
    50003,
    {anyOfCapabilitiesList: 0},
    null,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         null),
    1);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[50003] = new jspb.ExtensionFieldBinaryInfo(
    proto.authz.anyOfCapabilitiesList,
    jspb.BinaryReader.prototype.readPackedEnum,
    jspb.BinaryWriter.prototype.writePackedEnum,
    undefined,
    undefined,
    true);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[50003] = proto.authz.anyOfCapabilitiesList;

goog.object.extend(exports, proto.authz);
